import { render, staticRenderFns } from "./ExpirySyncDateEditor.vue?vue&type=template&id=69484c94"
import script from "./ExpirySyncDateEditor.vue?vue&type=script&lang=js"
export * from "./ExpirySyncDateEditor.vue?vue&type=script&lang=js"
import style0 from "./ExpirySyncDateEditor.vue?vue&type=style&index=0&id=69484c94&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QDate from 'quasar/src/components/date/QDate.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QColor from 'quasar/src/components/color/QColor.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon,QDate,QBtn,QColor});qInstall(component, 'directives', {ClosePopup});
